import { connect } from 'react-redux'
import { PrepareOrderButtonComponent } from './PrepareOrderButtonComponent'
import type {
    PurchasableItem,
    SendOrderPrepare
} from 'shared/store/ecommerce/order'
import {
    fillCartWithMultipleProducts,
    isTableServiceAvailable,
    prepareOrder,
    setCollectMode,
    setRestaurant
} from 'shared/store/ecommerce/order'
import { fetchCatalog } from 'shared/store/ecommerce/catalog'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { RestaurantShortDTO } from 'shared/types'
import { ecommOrderToCart } from 'shared/store/ecommerce/catalog/itemSelectors'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => {
    const { cacOrders, parkingOpen } = state.ecommerceOrderState
    const { available: availableFeatures } = state.featuresState

    return {
        cacOrders,
        parkingOpen,
        state: state.ecommerceCatalogState,
        availableFeatures
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    prepareOrder: (orderPrepare: SendOrderPrepare) =>
        d(prepareOrder(orderPrepare)),
    setRestaurant: (restaurant: RestaurantShortDTO) =>
        d(setRestaurant(restaurant)),
    setCollectMode: (collectMode: string) => d(setCollectMode(collectMode)),
    fillCartWithMultipleProducts: (products?: Array<PurchasableItem>) =>
        d(fillCartWithMultipleProducts(products)),
    fetchCatalog: (restaurantId: string) => d(fetchCatalog(restaurantId)),
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        ),
    isTableServiceAvailable: (restaurantId: string) =>
        d(isTableServiceAvailable(restaurantId))
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    handleError: async (token: string, missingProducts: boolean) => {
        const { cacOrders, state } = stateProps
        if (cacOrders) {
            const currentOrder = cacOrders[token]
            if (
                currentOrder &&
                currentOrder.restaurant &&
                currentOrder.pickUpType
            ) {
                await dispatchProps.setRestaurant(currentOrder.restaurant)
                try {
                    await dispatchProps.fetchCatalog(currentOrder.restaurant.id)
                } catch (error) {
                    console.error('error fetching catalog', error)
                }
                dispatchProps.setCollectMode(currentOrder.pickUpType)
                if (!missingProducts) {
                    const cart = ecommOrderToCart(currentOrder, state)
                    dispatchProps.fillCartWithMultipleProducts(cart)
                }
            }
        }
    },
    ...stateProps,
    ...dispatchProps,
    ...ownProps
})

const PrepareOrderButton = connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
)(PrepareOrderButtonComponent)

export { PrepareOrderButton }
